import { DialogComponentContent } from './../../../models/dialogs/DialogComponentContent';
import { Component, Inject, ElementRef, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	styleUrls: ['./confirm.component.scss'],
	templateUrl: './confirm.component.html',
	encapsulation: ViewEncapsulation.Emulated,
})

export class ConfirmComponent extends DialogComponentContent {
	public iconId: string;
	public title: string;
	public message: string;
	public confirmButtonLabel: string;
	public cancelButtonLabel: string;
	public panel: boolean = false;
	public destructiveAction: boolean = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<ConfirmComponent>,
		public element: ElementRef,
	) {
		super(element);

		if (data && data.destructiveAction) {

			this.destructiveAction = true;
			this.iconId = data.iconId;

		}

	}

	public dispose(result: boolean): void {
		this.dialogRef.close(result);
	}

}
